import React, { useMemo, useState, useEffect, useCallback } from "react";
import ResizableHeader from "../../shared/ResizableHeader";
import TablePagination from "../../shared/TablePagination";
import useAutoAdvancePagination from "../../shared/useAutoAdvancePagination";
import ExportLoader from "../../shared/ExportLoader";
import useReportExport from "../../shared/useReportExport";
import axios from "axios";
import WindowHeader from "../../Layout/WindowHeader/WindowHeader";
import ActionToolbar from "../../NavBars/ActionToolbar";
import headeLogo from "../../../assets/images/shersoftnavLogo.png";
import { useDbContext } from "../../../context/DbContext";
import GridDesign from "../../GridDesign/GridDesign";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useSelector } from "react-redux";
import { selectActiveLocation } from "../../../app/locationSlice";
import { selectActiveFyid } from "../../../app/financialYearSlice";

const getDefaultColumns = (reportType) => {
  const rType = String(reportType || "Summary").toLowerCase();
  let list = [];
  if (rType.includes("item")) {
    list = [
      { key: "SlNo", label: "Sl No", width: 60, align: "center" },
      { key: "Date", label: "Date", width: 90, align: "center" },
      { key: "EntryNo", label: "Entry No", width: 80, align: "right" },
      { key: "InvoiceNo", label: "Inv No", width: 100 },
      { key: "Supplier", label: "Supplier", width: 160 },
      { key: "GSTNo", label: "GST No", width: 110 },
      { key: "ItemCode", label: "Item Code", width: 85 },
      { key: "ItemName", label: "Item Name", width: 150 },
      { key: "SalesMan", label: "Sales Man", width: 100 },
      { key: "Location", label: "Location", width: 100 },
      { key: "Qty", label: "Qty", width: 65, align: "right" },
      { key: "GrWt", label: "Gross Wt", width: 90, align: "right" },
      { key: "StoneWt", label: "Stone Wt", width: 85, align: "right" },
      { key: "MudLess", label: "Mud Less", width: 85, align: "right" },
      { key: "Wstg", label: "Wastage", width: 85, align: "right" },
      { key: "NetWt", label: "Net Wt", width: 90, align: "right" },
      { key: "Touch", label: "Touch %", width: 75, align: "right" },
      { key: "PureWt", label: "Pure Wt", width: 90, align: "right" },
      { key: "LessWt", label: "Less Wt", width: 80, align: "right" },
      { key: "LessPerc", label: "Less %", width: 75, align: "right" },
      { key: "MC", label: "Making Chg", width: 95, align: "right" },
      { key: "StoneAmt", label: "Stone Amt", width: 95, align: "right" },
      { key: "Rate", label: "Rate/Gm", width: 95, align: "right" },
      { key: "GrossValue", label: "Gross Val", width: 110, align: "right" },
      { key: "Discount", label: "Discount", width: 90, align: "right" },
      { key: "NetAmount", label: "Net Amt", width: 110, align: "right" },
      { key: "CGST", label: "CGST", width: 90, align: "right" },
      { key: "SGST", label: "SGST", width: 90, align: "right" },
      { key: "IGST", label: "IGST", width: 90, align: "right" },
      { key: "Total", label: "Total", width: 120, align: "right" },
      { key: "PType", label: "Type", width: 75 }
    ];
  } else if (rType.includes("capital") || rType.includes("expense")) {
    list = [
      { key: "Date", label: "Date", width: 100, align: "center" },
      { key: "InvNo", label: "Inv No", width: 110 },
      { key: "EntryNo", label: "Entry No", width: 90, align: "right" },
      { key: "Location", label: "Location", width: 140 },
      { key: "Supplier", label: "Supplier", width: 180 },
      { key: "Amount", label: "Amount", width: 110, align: "right" },
      { key: "CGST", label: "CGST", width: 95, align: "right" },
      { key: "SGST", label: "SGST", width: 95, align: "right" },
      { key: "IGST", label: "IGST", width: 95, align: "right" },
      { key: "Total", label: "Total", width: 110, align: "right" },
      { key: "Roundoff", label: "Round Off", width: 90, align: "right" },
      { key: "GrandTotal", label: "Grand Total", width: 120, align: "right" }
    ];
  } else {
    // Summary
    list = [
      { key: "Slno", label: "Sl No", width: 60, align: "center" },
      { key: "Date", label: "Date", width: 90, align: "center" },
      { key: "EntryNo", label: "Entry No", width: 80, align: "right" },
      { key: "InvDate", label: "Inv Date", width: 90, align: "center" },
      { key: "Suppplier", label: "Supplier", width: 160 },
      { key: "SupInvNo", label: "Sup Inv No", width: 100 },
      { key: "SalesMan", label: "Sales Man", width: 100 },
      { key: "Location", label: "Location", width: 100 },
      { key: "PType", label: "Type", width: 75 },
      { key: "PurchaseType", label: "Purchase Type", width: 110 },
      { key: "TaxType", label: "Tax Type", width: 80 },
      { key: "TotalQty", label: "Total Qty", width: 85, align: "right" },
      { key: "TotalGrWt", label: "Total Gr Wt", width: 100, align: "right" },
      { key: "TotalStonewt", label: "Total St Wt", width: 95, align: "right" },
      { key: "TotalMudless", label: "Total Mud", width: 95, align: "right" },
      { key: "TotalWstg", label: "Total Wstg", width: 95, align: "right" },
      { key: "TotalNetwt", label: "Total Net Wt", width: 100, align: "right" },
      { key: "TotalPureWt", label: "Total Pure", width: 100, align: "right" },
      { key: "TotalLess", label: "Total Less", width: 90, align: "right" },
      { key: "TotalMc", label: "Total MC", width: 100, align: "right" },
      { key: "TotalStAmt", label: "Total St Amt", width: 100, align: "right" },
      { key: "GrossValue", label: "Gross Val", width: 110, align: "right" },
      { key: "Discount", label: "Discount", width: 95, align: "right" },
      { key: "NetAmount", label: "Net Amt", width: 110, align: "right" },
      { key: "CGST", label: "CGST", width: 100, align: "right" },
      { key: "SGST", label: "SGST", width: 100, align: "right" },
      { key: "IGST", label: "IGST", width: 100, align: "right" },
      { key: "Cess", label: "Cess", width: 90, align: "right" },
      { key: "Total", label: "Total", width: 120, align: "right" },
      { key: "OtherCharges", label: "Other Chg", width: 100, align: "right" },
      { key: "RoundOff", label: "Round Off", width: 90, align: "right" },
      { key: "GrandTotal", label: "Grand Total", width: 125, align: "right" },
      { key: "CashPaid", label: "Cash Paid", width: 115, align: "right" }
    ];
  }

  return list.map((col, idx) => ({
    ...col,
    columnName: col.key,
    header: col.label,
    orderNo: idx,
    show: true
  }));
};

function PurchaseList({ onClose, payload = {}, zIndex }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { dbCode } = useDbContext();
  const [reportRows, setReportRows] = useState([]);
  const [reportTotals, setReportTotals] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const reportType = payload.reportType || "Summary";
  const formName = `Purchase List - ${reportType}`;

  const [gridColumns, setGridColumns] = useState(() => getDefaultColumns(reportType));
  const [showGridDesignModal, setShowGridDesignModal] = useState(false);

  // Load grid settings from database / cache
  useEffect(() => {
    const loadGridSettings = async () => {
      if (!dbCode || !formName) return;

      const defaults = getDefaultColumns(reportType);

      // Check Local Storage cache first
      let cached = localStorage.getItem(`grid_design_${formName}`);
      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          setGridColumns(parsed);
          return;
        } catch (e) {
          console.error("Error parsing cached grid settings:", e);
        }
      }

      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/griddesign/${dbCode}/${formName}`
        );
        const dbCols = response.data.recordset || response.data || [];
        if (dbCols.length > 0) {
          const merged = defaults.map((initCol) => {
            const dbMatch = dbCols.find(
              (c) =>
                String(c.ColName).toLowerCase() ===
                String(initCol.columnName).toLowerCase()
            );
            if (dbMatch) {
              return {
                ...initCol,
                width: dbMatch.Width !== null ? dbMatch.Width : initCol.width,
                orderNo: dbMatch.InNo !== null ? dbMatch.InNo : initCol.orderNo,
                header: dbMatch.Header || initCol.header,
                show: dbMatch.Vis === 1
              };
            }
            return initCol;
          });
          merged.sort((a, b) => a.orderNo - b.orderNo);
          localStorage.setItem(`grid_design_${formName}`, JSON.stringify(merged));
          setGridColumns(merged);
        } else {
          setGridColumns(defaults);
        }
      } catch (error) {
        console.error("Error loading grid settings:", error);
        setGridColumns(defaults);
      }
    };
    loadGridSettings();
  }, [dbCode, apiBaseUrl, formName, reportType]);

  const visibleColumns = useMemo(
    () => gridColumns.filter((col) => col.show),
    [gridColumns]
  );

  const gridTemplateColumns = useMemo(
    () => visibleColumns.map((col) => `${col.width}px`).join(" "),
    [visibleColumns]
  );

  const activeLocation = useSelector(selectActiveLocation);
  const activeFyid = useSelector(selectActiveFyid);

  const requestPayload = useMemo(() => {
    const loc = (payload.locationId !== undefined && payload.locationId !== "") 
      ? Number(payload.locationId) 
      : ((payload.location !== undefined && payload.location !== "") ? Number(payload.location) : 0);
    return {
      ...payload,
      locationId: loc,
      location: loc,
      fyid: (payload.fyid !== undefined && payload.fyid !== null && payload.fyid !== "") 
        ? Number(payload.fyid) 
        : (activeFyid || 0),
    };
  }, [payload, activeFyid]);

  useEffect(() => {
    if (!dbCode) return;
    setIsLoading(true);
    setErrorMsg("");

    axios
      .post(`${apiBaseUrl}/purchasereport/list/${dbCode}`, requestPayload)
      .then((res) => {
        if (res.data && res.data.success) {
          setReportRows(res.data.data || []);
          setReportTotals(res.data.totals || {});
        } else {
          setErrorMsg(res.data?.message || "Failed to load report data");
        }
      })
      .catch((err) => {
        console.error("Error loading purchase report:", err);
        setErrorMsg("Error connecting to server. Please try again.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [dbCode, apiBaseUrl, requestPayload]);

  const formatValue = (row, key) => {
    const val = row[key];
    if (val === null || val === undefined) return "";
    if (typeof val === "number") {
      if (key.toLowerCase().includes("qty")) return val.toFixed(0);
      if (key.toLowerCase().includes("wt") || key.toLowerCase().includes("mud")) return val.toFixed(3);
      return val.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return String(val);
  };

  // ── Client-side Quick Search Filter ──
  const filteredRows = useMemo(() => {
    if (!searchQuery.trim()) return reportRows;
    const query = searchQuery.toLowerCase().trim();
    return reportRows.filter((row) =>
      visibleColumns.some((col) => {
        const val = formatValue(row, col.key);
        return val.toLowerCase().includes(query);
      })
    );
  }, [reportRows, searchQuery, visibleColumns]);

  // ── Dynamic Totals based on filtered rows ──
  const dynamicTotals = useMemo(() => {
    const numericColumns = [
      "Qty", "GrWt", "StoneWt", "MudLess", "Wstg", "NetWt", "Touch", "PureWt", "LessWt", "LessPerc", 
      "MC", "StoneAmt", "Rate", "GrossValue", "Discount", "NetAmount", "CGST", "SGST", "IGST", "Cess", 
      "Total", "OtherCharges", "RoundOff", "GrandTotal", "CashPaid",
      "TotalQty", "TotalGrWt", "TotalStonewt", "TotalMudless", "TotalWstg", "TotalNetwt", "TotalPureWt", "TotalLess", "TotalMc", "TotalStAmt"
    ];

    if (!searchQuery.trim()) return reportTotals;

    return filteredRows.reduce((acc, row) => {
      numericColumns.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(row, key)) {
          acc[key] = (acc[key] || 0) + (Number(row[key]) || 0);
        }
      });
      return acc;
    }, {});
  }, [filteredRows, reportTotals, searchQuery]);

  const selectedFormsText = Array.isArray(payload.selectedForms)
    ? payload.selectedForms.join(", ")
    : "";

  const {
    currentPage,
    pageSize,
    pageSizeOptions,
    totalPages,
    totalRows,
    displayedRows,
    selectedIndex,
    setSelectedIndex,
    tableContainerRef,
    handleScroll,
    handleWheel,
    handleKeyDown,
    handlePageChange,
    handlePageSizeChange,
    autoAdvance,
    toggleAutoAdvance,
    isFlipping,
  } = useAutoAdvancePagination({
    items: filteredRows,
    initialPageSize: 100,
    pageSizeOptions: [50, 100, 250, 500],
    initialAutoAdvance: true,
  });

  const { exportingText, runExport } = useReportExport();

  const exportToCsv = () => {
    runExport("Generating Excel / CSV...", () => {
      const header = visibleColumns.map((col) => col.header).join(",");
      const rows = filteredRows.map((row) =>
        visibleColumns
          .map((col) => `"${String(row[col.key] ?? "").replace(/"/g, '""')}"`)
          .join(",")
      );
      const totalRow = visibleColumns.map((col) => {
        if (col.key === "Suppplier" || col.key === "Supplier") return '"Total"';
        if (dynamicTotals[col.key] !== undefined) return `"${dynamicTotals[col.key]}"`;
        return '""';
      }).join(",");

      const csv = [header, ...rows, totalRow].join("\n");
      const link = document.createElement("a");
      link.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      link.download = `purchase_list_${reportType}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  // ==================== PDF EXPORT (SchemeReport Style) ====================
  const exportToFullPDF = () => {
    runExport("Generating PDF Report...", () => {
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a2",
      });

      const columns = visibleColumns.map((col, idx) => ({
        header: col.header,
        dataKey: `col${idx + 1}`,
      }));

      const rows = filteredRows.map((item) => {
        const row = {};
        visibleColumns.forEach((col, idx) => {
          row[`col${idx + 1}`] = formatValue(item, col.key);
        });
        return row;
      });

      // Add totals row at the bottom
      const totalRow = {};
      visibleColumns.forEach((col, idx) => {
        if (col.key === "Suppplier" || col.key === "Supplier") {
          totalRow[`col${idx + 1}`] = "Total";
        } else if (dynamicTotals[col.key] !== undefined) {
          totalRow[`col${idx + 1}`] = formatValue(dynamicTotals, col.key);
        } else {
          totalRow[`col${idx + 1}`] = "";
        }
      });
      rows.push(totalRow);

      doc.text(`Purchase List Report (${reportType})`, 15, 20);
      doc.autoTable({
        columns,
        body: rows,
        startY: 30,
        margin: { top: 30 },
        styles: { fontSize: 8 },
      });

      doc.save(`purchase_list_${reportType.toLowerCase()}.pdf`);
    });
  };

  // Stable column resize handler (shared ResizableHeader imported at module scope)
  const handleColumnResize = useCallback((key, newWidth, name) => {
    setGridColumns((prev) => {
      const updated = prev.map((c) => (c.key === key ? { ...c, width: newWidth } : c));
      localStorage.setItem(`grid_design_${name}`, JSON.stringify(updated));
      return updated;
    });
  }, []);

  return (
    <div
      className="bg-white mt-[2vh] sm:mt-0 font-normal w-[98vw] h-[96vh] rounded-[5px] shadow-md flex flex-col items-center absolute transition-all duration-300 md:w-[98%] md:h-[98%]"
      style={{ zIndex }}
    >
      <style>{`
        .purchase-list-border {
          border: 1px solid #ffffff;
        }
        .report-scroll::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }
        .report-scroll::-webkit-scrollbar-track {
          background: #f1f1f1;
        }
        .report-scroll::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 4px;
        }
        .report-scroll::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }
      `}</style>

      <WindowHeader
        onClose={onClose}
        title="Purchase List"
        logo={headeLogo}
        style={{ height: "30px" }}
        className="bg-[#0f56d3] text-white"
        titleClassName="text-xs"
        closeBtnClassName="w-6 h-6 rounded-[5px] border-none mr-2 flex items-center justify-center"
      />

      <ActionToolbar
        size="small"
        iconSize={16}
        buttonHeight="36px"
        showSave={false}
        showPrint
        showClear={false}
        showFind={false}
        showEdit={false}
        showDelete={false}
        showExit
        showPdf
        showExcel
        showSettingsBar
        showRefresh={false}
        showNavigation={false}
        onPrint={() => window.print()}
        onExcel={exportToCsv}
        onPdf={exportToFullPDF}
        onExit={onClose}
        settingsOptions={[
          {
            label: "Design Columns",
            onClick: () => setShowGridDesignModal(true),
          }
        ]}
      />

      <div className="w-full flex-1 min-h-0 flex flex-col bg-white">
        {/* Info panel + Search Bar */}
        <div className="w-full border-b border-gray-200 bg-gradient-to-r from-slate-50 to-blue-50/20 px-4 py-2 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-[11px] font-Inter text-slate-700 flex-1">
            
            {/* Period Badge */}
            <div className="flex items-center gap-1.5 bg-white border border-slate-200 shadow-sm px-2.5 py-1 rounded-[6px]">
              <svg className="w-3.5 h-3.5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <span className="font-semibold text-slate-500">Period:</span>
              <span className="font-medium text-slate-900">{payload.fromDate || "-"} to {payload.toDate || "-"}</span>
            </div>

            {/* Report Type Badge */}
            <div className="flex items-center gap-1.5 bg-white border border-slate-200 shadow-sm px-2.5 py-1 rounded-[6px]">
              <svg className="w-3.5 h-3.5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17v-2m3 2v-4m3 4v-6m2 10H3a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2v14a2 2 0 01-2 2z" />
              </svg>
              <span className="font-semibold text-slate-500">Report:</span>
              <span className="font-medium text-indigo-700">{payload.reportType || "Summary"}</span>
            </div>

            {/* Voucher Badge */}
            <div className="flex items-center gap-1.5 bg-white border border-slate-200 shadow-sm px-2.5 py-1 rounded-[6px]">
              <svg className="w-3.5 h-3.5 text-emerald-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="font-semibold text-slate-500">Voucher:</span>
              <span className="font-medium text-emerald-700">{payload.voucherType || "All"}</span>
            </div>

            {/* Order By Badge */}
            <div className="flex items-center gap-1.5 bg-white border border-slate-200 shadow-sm px-2.5 py-1 rounded-[6px]">
              <svg className="w-3.5 h-3.5 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12" />
              </svg>
              <span className="font-semibold text-slate-500">Order By:</span>
              <span className="font-medium text-slate-900">{payload.orderBy || "Entry No"}</span>
            </div>

            {/* Forms Badge */}
            <div className="flex items-center gap-1.5 bg-white border border-slate-200 shadow-sm px-2.5 py-1 rounded-[6px] max-w-xs">
              <svg className="w-3.5 h-3.5 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
              </svg>
              <span className="font-semibold text-slate-500">Forms:</span>
              <span className="font-medium text-slate-900 truncate">{selectedFormsText || "All Purchase Forms"}</span>
            </div>

            {payload.itemName && (
              <div className="flex items-center gap-1.5 bg-white border border-slate-200 shadow-sm px-2.5 py-1 rounded-[6px]">
                <svg className="w-3.5 h-3.5 text-rose-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                </svg>
                <span className="font-semibold text-slate-500">Item:</span>
                <span className="font-medium text-slate-900">{payload.itemName}</span>
              </div>
            )}

            {payload.location && (
              <div className="flex items-center gap-1.5 bg-white border border-slate-200 shadow-sm px-2.5 py-1 rounded-[6px]">
                <svg className="w-3.5 h-3.5 text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="font-semibold text-slate-500">Location:</span>
                <span className="font-medium text-slate-900">{payload.location}</span>
              </div>
            )}

            {payload.groupName && (
              <div className="flex items-center gap-1.5 bg-white border border-slate-200 shadow-sm px-2.5 py-1 rounded-[6px]">
                <svg className="w-3.5 h-3.5 text-cyan-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
                <span className="font-semibold text-slate-500">Group:</span>
                <span className="font-medium text-slate-900">{payload.groupName}</span>
              </div>
            )}

            {payload.rateClassName && (
              <div className="flex items-center gap-1.5 bg-white border border-slate-200 shadow-sm px-2.5 py-1 rounded-[6px]">
                <svg className="w-3.5 h-3.5 text-lime-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
                <span className="font-semibold text-slate-500">Rate Class:</span>
                <span className="font-medium text-slate-900">{payload.rateClassName}</span>
              </div>
            )}

            {payload.modelName && (
              <div className="flex items-center gap-1.5 bg-white border border-slate-200 shadow-sm px-2.5 py-1 rounded-[6px]">
                <svg className="w-3.5 h-3.5 text-fuchsia-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="font-semibold text-slate-500">Model:</span>
                <span className="font-medium text-slate-900">{payload.modelName}</span>
              </div>
            )}

          </div>

          {/* Quick Search */}
          <div className="flex items-center shrink-0">
            <div className="relative w-64">
              <input
                type="text"
                placeholder="Search across all columns..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-9 pr-7 py-1.5 text-xs border border-slate-300 rounded-[8px] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-Inter font-semibold text-slate-800 bg-white shadow-sm transition-all placeholder-slate-400"
              />
              <svg
                className="absolute left-3 top-2.5 h-3.5 w-3.5 text-slate-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery("")}
                  className="absolute right-2.5 top-2.5 text-gray-400 hover:text-gray-600 text-xs font-semibold px-1"
                >
                  ✕
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Grid and Loader */}
        <div
          ref={tableContainerRef}
          className="w-full flex-1 min-h-0 overflow-auto text-black text-xs font-semibold report-scroll outline-none focus:ring-1 focus:ring-blue-400"
          tabIndex={0}
          onScroll={handleScroll}
          onWheel={handleWheel}
          onKeyDown={handleKeyDown}
        >
          {isLoading ? (
            <div className="w-full h-full flex items-center justify-center bg-white/70">
              <div className="flex flex-col items-center gap-3">
                <div className="w-8 h-8 border-4 border-[#0f56d3] border-t-transparent rounded-full animate-spin"></div>
                <span className="font-Inter text-[13px] text-gray-600 font-medium">Fetching Report Data...</span>
              </div>
            </div>
          ) : errorMsg ? (
            <div className="w-full h-full flex items-center justify-center bg-white">
              <span className="font-Inter text-[13px] text-red-500 font-medium">{errorMsg}</span>
            </div>
          ) : filteredRows.length === 0 ? (
            <div className="w-full h-full flex items-center justify-center bg-white">
              <span className="font-Inter text-[13px] text-gray-400 font-medium">No records found for the selected filters.</span>
            </div>
          ) : (
            <div className="min-w-max flex flex-col min-h-full">
              {/* Header Row */}
              <div className="sticky top-0 z-10 bg-blue-600 purchase-list-border shrink-0">
                <div className="grid gap-0 h-8" style={{ gridTemplateColumns }}>
                  {visibleColumns.map((col) => (
                    <div
                      key={col.key}
                      className="text-white truncate text-center font-semibold font-Inter purchase-list-border text-xs w-full h-full flex items-center justify-center"
                    >
                      <ResizableHeader col={col} formName={formName} onResize={handleColumnResize}>
                        {col.header}
                      </ResizableHeader>
                    </div>
                  ))}
                </div>
              </div>

              {/* Data Rows */}
              <div className="bg-gray-100 flex-1">
                {displayedRows.map((row, rowIndex) => {
                  const isHeaderStub = row.EntryNo === null || row.EntryNo === undefined;
                  if (isHeaderStub) {
                    return (
                      <div
                        key={rowIndex}
                        data-row-index={rowIndex}
                        className="h-8 bg-blue-100/75 border-b border-gray-300 px-4 flex items-center text-blue-900 font-bold font-Inter text-[11px] uppercase tracking-wide sticky left-0"
                      >
                        {row.Date || row.ptype || row.PType || "Section"}
                      </div>
                    );
                  }

                  const isSelected = rowIndex === selectedIndex;
                  return (
                    <div
                      key={rowIndex}
                      data-row-index={rowIndex}
                      onClick={() => setSelectedIndex(rowIndex)}
                      className={`grid gap-0 h-8 border-b border-gray-300 hover:bg-blue-50/40 cursor-pointer transition-colors duration-150 ${
                        isSelected
                          ? "bg-blue-100 font-bold text-blue-900 ring-1 ring-inset ring-blue-500"
                          : rowIndex % 2 === 0
                          ? "bg-[#f7f7f7]"
                          : "bg-[#eeeeee]"
                      }`}
                      style={{ gridTemplateColumns }}
                    >
                      {visibleColumns.map((col) => (
                        <div
                          key={col.key}
                          className={`font-Inter text-[11px] font-medium purchase-list-border px-2 flex items-center truncate ${
                            col.align === "right" ? "justify-end text-right" : ""
                          }`}
                        >
                          {formatValue(row, col.key)}
                        </div>
                      ))}
                    </div>
                  );
                })}
              </div>

              {/* Footer Totals Row */}
              <div className="grid gap-0 h-8 bg-[#dbeafe] text-blue-800 font-bold sticky bottom-0 z-10 shrink-0" style={{ gridTemplateColumns }}>
                {visibleColumns.map((col) => {
                  let text = "";
                  if (col.key === "Suppplier" || col.key === "Supplier") {
                    text = "Total";
                  } else if (dynamicTotals[col.key] !== undefined) {
                    text = formatValue(dynamicTotals, col.key);
                  }

                  return (
                    <div
                      key={col.key}
                      className={`font-Inter text-[11px] purchase-list-border px-2 flex items-center truncate ${
                        col.align === "right" ? "justify-end text-right" : ""
                      }`}
                    >
                      {text}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
        <TablePagination
          currentPage={currentPage}
          totalRows={totalRows}
          pageSize={pageSize}
          pageSizeOptions={pageSizeOptions}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          autoAdvance={autoAdvance}
          onToggleAutoAdvance={toggleAutoAdvance}
          isFlipping={isFlipping}
        />
      </div>

      {showGridDesignModal && (
        <GridDesign
          onClose={() => setShowGridDesignModal(false)}
          onSave={(updated) => {
            setGridColumns(updated);
            setShowGridDesignModal(false);
          }}
          formName={formName}
          initialColumns={getDefaultColumns(reportType)}
          zIndex={zIndex}
        />
      )}

      {/* Global Export Loader for Heavy Operations */}
      <ExportLoader message={exportingText} />
    </div>
  );
}

export default PurchaseList;
